import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import geoGroupRoutes from '../../../routes/geoGroupRoutes';

const update = createAsyncThunk(
  'thunk/geoGroup/update',
  async (arg, thunkAPI) => {
    const response = await apiFetch(geoGroupRoutes.api.generate.update(arg?.id), {
      body: arg?.data,
      method: 'POST',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
